import { BUSINESS_CHECKING_ACCOUNT } from 'axp-product-ducks';
import { STATUS, BUSINESS_SAVINGS_ACCOUNT } from '../constants';

const isBusinessBankingProduct = (product) =>
  [BUSINESS_CHECKING_ACCOUNT, BUSINESS_SAVINGS_ACCOUNT].includes(product.type);

const getDefaultProduct = (products) => {
  const isActiveBusinessBankingProduct = (product) =>
    isBusinessBankingProduct(product) && product.status === STATUS.ACTIVE;
  return (
    products.find(isActiveBusinessBankingProduct) ||
    products.find(isBusinessBankingProduct)
  );
};

const isProductBusinessBanking = (products, productId) => {
  if (productId === null || !Array.isArray(products)) {
    return false;
  }

  return products.some(
    (product) =>
      product.opaqueAccountId === productId && isBusinessBankingProduct(product)
  );
};

export { getDefaultProduct, isProductBusinessBanking };
